export default __webpack_public_path__ + "static/media/sky diving.7a556d3c.jpg";